export default {
  // table
  application_table_name: '应用名称',
  application_table_installation_date: '安装日期',
  application_table_status_enable: '使用中',
  application_table_status_disable: '已禁用',
  application_confirm_content: '应用名称: {name}',
  application_confirm_delete_title: '确定删除该应用?',
  application_confirm_enable_title: '确定启用该应用?',
  application_confirm_disable_title: '确定禁用该应用?',
  // user
  application_menu: '应用接入',
  application_menu_add: '应用接入添加',
  application_menu_edit: '应用接入编辑',
  application_menu_detail: '应用接入详情',
  // form
  application_form_name: '应用名称',
  application_form_name_placeholder: '请输入应用名称',
  application_form_status: '应用状态',
  application_form_status_placeholder: '请选择状态',
  application_form_description: '应用描述',
  application_form_description_placeholder: '请输入应用描述',
  application_form_icon: '应用图标',
  application_form_bind_username: '绑定用户',
  application_form_bind_username_placeholder: '请选择要绑定的用户',
  application_form_app_id_placeholder: '请输入appId',
  application_form_app_secret_placeholder: '请输入appSecret',
  application_form_auto_generation_placeholder: '由系统自动生成',
  application_form_installTime: '安装时间',
  application_form_installTime_placeholder: '请选择安装时间',
  // detail
  application_detail_basic_info: '基本信息',
  application_detail_affiliation_name: '隶属名称',
  application_detail_status: '状态',
  application_detail_access_user: '接入人',
  application_detail_access_time: '接入时间',
  application_detail_descrption: '描述',
  application_detail_path: '路径',
  application_detail_bindUser: '绑定用户',
  application_detail_auth: '应用凭证',
};
